import React from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

const Container = styled.div`
  font-size: 14px;
`;

type Props = { shopDate: string; dataTestId?: string };

const CMASummaryTableDataShopDate = ({ shopDate, dataTestId }: Props) => (
  <Container data-test-id={dataTestId}>{shopDate ? dayjs(shopDate).format('MMM DD YYYY') : '-'}</Container>
);

export default CMASummaryTableDataShopDate;
